import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, MapPin, Clock, ArrowRight } from "lucide-react";
import { inr } from "@/lib/format";

export default function ExperienceGrid({ items = [], prefix = "exp" }) {
  if (!items.length) return null;
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((e, i) => (
        <motion.div key={e.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}
          className="group flex flex-col rounded-2xl overflow-hidden border border-primary/10 bg-card" data-testid={`${prefix}-card-${i}`}>
          <Link to={`/experience/${e.id}`} className="h-52 overflow-hidden relative block">
            <img src={e.image} alt={e.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <span className="absolute top-3 left-3 rounded-full bg-white/90 text-primary text-xs font-semibold px-3 py-1">{e.category_label}</span>
            {e.mode === "discovery" && <span className="absolute top-3 right-3 rounded-full bg-primary/80 text-white text-xs font-semibold px-3 py-1">Enquire</span>}
          </Link>
          <div className="p-6 flex flex-col flex-1">
            <div className="flex items-center gap-1 text-xs text-muted-foreground"><MapPin size={12} /> {e.location}</div>
            <h3 className="font-semibold text-xl mt-1.5 text-foreground">{e.title}</h3>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed flex-1">{e.description}</p>
            <div className="flex items-center gap-4 text-xs text-muted-foreground mt-3">
              <span className="flex items-center gap-1"><Clock size={12} /> {e.duration}</span>
              <span className="flex items-center gap-1"><Star size={12} className="fill-accent text-accent" /> {e.rating}</span>
              {e.difficulty && <span>{e.difficulty}</span>}
            </div>
            <div className="flex items-center justify-between mt-4 pt-4 border-t border-primary/10">
              <span className="font-display text-2xl text-foreground">{inr(e.price)}<span className="text-xs text-muted-foreground font-sans"> /person</span></span>
              <Link to={`/experience/${e.id}`} className="inline-flex items-center gap-1.5 rounded-full bg-accent text-accent-foreground px-5 py-2.5 text-sm font-semibold hover:-translate-y-px transition-transform" data-testid={`${prefix}-view-${i}`}>
                {e.mode === "discovery" ? "Enquire" : "Book"} <ArrowRight size={15} />
              </Link>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
